module.exports = __webpack_public_path__ + "img/share_black_icon.4cf5ced0.svg";